{
  "new": {
    "title": "Configuration des contrats",
    "tabs": {
      "add": "Ajout",
      "generate": "Génération",
      "management": "Gestion",
      "signing": "Signature"
    }
  },
  "infos": {
    "generated_contract": "Contrats générés"
  },
  "add_contract": {
    "contract": "Contrat",
    "generate": "Générer"
  },
  "deposit": {
    "title": "Dépôts",
    "tabs": {
      "idahe2": "IDAHE 2",
      "eps": "EPS"
    },
    "modal": {
      "title": "Évènement en cours",
      "caution": "Attention: ",
      "warning_text_deposit": "il n'y a aucun dépôt qui n'est pas encore validé. | il y a {n} dépôt qui n'est pas encore validé: | il y a {n} dépôts qui ne sont pas encore validés:",
      "warning_text_contract": "il n'y a aucun contrat qui n'est pas encore signé. | il y a {n} contrat qui n'est pas encore signé: | il y a {n} contrats qui ne sont pas encore signés:",
      "description": "La gestion des contrats et les soumissions ne seront plus accessibles. Souhaitez-vous déclarer l’évènement en cours ?",
      "button": "Déclarer l'évènement en cours"
    },
    "floating_action_bar": {
      "buttons": {
        "send_to_bot": "Initialiser le dépôt",
        "create_manual_submission": "Dépôt manuel"
      }
    }
  },
  "deposit_info": {
    "title": "Informations dépôts"
  },
  "management_contract": {
    "sign_status": "Statut signature",
    "deposit_status": "Statut dépôt",
    "upload_document": "Téléverser votre document",
    "joint_file": "Renseignez le type de fichier joint",
    "add_a_file": "Ajouter un fichier",
    "signed_at": "Date de signature du contrat signé",
    "regime": "Régime",
    "sign": "Envoyer en signature",
    "deposit": "Déposer",
    "reminder": "Relancer",
    "event_in_progress": "Déclarer l'évènement en cours",
    "custom_type_name": "Nom du fichier",
    "buttons": {
      "sign_all": "Tout signer",
      "remind_all": "Tout relancer",
      "download_contracts_zip": "Télécharger le zip des contrats"
    },
    "documents": {
      "SIGNED_CONTRACT": "Contrat signé / Convention d'hospitalité signée",
      "CONTRACT": "Contrat",
      "ORDER_RESPONSE": "Réponse de l'ordre",
      "ACTIVITY_AUTHORIZATION": "Autorisation cumul activité",
      "DIRECTOR_AUTHORIZATION": "Autorisation du directeur de l'établissement",
      "RECEIPT": "Récépissé",
      "SOLICITATION_LETTER": "Lettre de sollicitation",
      "STATUS": "Statuts",
      "RIB": "Rib",
      "OFFICIAL_JOURNAL": "Copie du Journal Officiel",
      "AMENDMENT_CONTRACT": "Avenant au contrat",
      "WORK_CERTIFICATE": "Attestation de travail",
      "DEAN_AUTHORIZATION": "Autorisation du doyen",
      "OTHER": "Autre"
    },
    "download_contracts_zip": {
      "modal": {
        "title": "Télécharger le zip des contrats",
        "unsigned_pdf": {
          "title": "PDF - Contrats non signés",
          "description": "Télécharger un zip des contrats non signés au format PDF"
        },
        "unsigned_docx": {
          "title": "DOCX  - Contrats non signés",
          "description": "Télécharger un zip des contrats non signés au format Docx (Attention, les formats pdf ne seront pas convertis en docx)"
        },
        "signed_pdf": {
          "title": "PDF - Contrats signés",
          "description": "Télécharger un zip des contrats signés au format PDF"
        },
        "no_generated_template": "Aucun fichier généré",
        "generated_at": "Fichier généré le: ",
        "button": {
          "validate": "Valider",
          "download": "Télécharger"
        }
      }
    },
    "modal": {
      "shared": {
        "legend": {
          "attendees": "invité(s)",
          "internes": "interne(s)"
        },
        "link_signers": "Lier le(s) signataire(s) au contrat",
        "select_internal_signer": "Veuillez sélectionner un signataire interne.",
        "selected_contract": "Vous avez sélectionné le contrat suivant :"
      },
      "ORDERED": {
        "title": "signature séquentielle",
        "subtitle": "Veuillez sélectionner au moins un signataire interne.",
        "signers_orders": "Les signataires seront envoyés avec l'ordre suivant :",
        "signers_orders_multiple_attendee": "Les signataires internes seront envoyés avec l'ordre suivant :",
        "multiple_attendee_selected": "Les invités signeront après les signataires internes."
      },
      "TRIPARTITE_UNORDERED": {
        "title": "signature tripartite parallèle",
        "subtitle": "Veuillez sélectionner le signataire interne du contrat",
        "signers_orders": "Tous les signataires recevront le contrat en même temps."
      },
      "TRIPARTITE_ORDERED": {
        "title": "signature tripartite séquentielle",
        "subtitle": "Veuillez sélectionner le signataire interne du contrat",
        "signers_orders": "Les signataires seront envoyés avec l'ordre suivant :"
      },
      "UNORDERED": {
        "title": "signature parallèle",
        "subtitle": "Veuillez sélectionner le(s) signataire(s) interne(s) du contrat",
        "signers_orders": "Tous les signataires recevront le contrat en même temps.",
        "without_internal_signer": "Continuer sans signataire interne"
      },
      "signature": {
        "selected_contract": "Vous avez sélectionné le contrat suivant :",
        "no_contracts_selected": "Aucun contrat n'est actuellement dans le statut à envoyer en signature.",
        "title": "Signature",
        "subtitle": "Veuillez sélectionner les signataires internes du document",
        "confirm": "Confirmez-vous l’envoi en signature ?",
        "sended_to": "Les contrats seront envoyés en signature à :",
        "forwarded_to": "Les contrats seront envoyés pour information à :",
        "sended": "Demande de signature envoyée. Vous allez recevoir un mail  pour notifier la signature."
      },
      "deposit": {
        "deposit_type": "1. Renseignez le type de dépôt :",
        "deposit_platform": "2. Sélectionner votre plateforme de dépôt :",
        "statement": "Déclaration",
        "authorization": "Autorisation"
      },
      "delete_contract": {
        "title": "Supprimer un contrat",
        "text": "La suppression de ce contrat de cet invité annulera la procédure de signature. Souhaitez vous supprimer ce contrat de cet invité ?",
        "button": "Supprimer le contrat"
      },
      "delete_attendee": {
        "title": "Supprimer un invité",
        "text": "Un contrat a été généré à cet invité, la suppression de cet invité annulera la procédure de signature. Souhaitez vous supprimer cet invité ?",
        "button": "Supprimer l'invité"
      },
      "reminder": {
        "title": "Relance",
        "confirm": "Confirmez-vous l'envoi de relances ?",
        "sended_to": "Des relances seront envoyées à :",
        "sended": "Relances envoyées."
      },
      "error_send": {
        "title": "Procédure de signature",
        "text": "La procédure de signature est en cours d'envoi.",
        "cancel": "Annuler la procédure de signature"
      }
    },
    "badge": {
      "sign_status": {
        "CREATING": "À envoyer",
        "PENDING": "Envoyé en signature",
        "DONE": "Signé",
        "SIGNING": "En cours de signature",
        "NOT_SENT": "Non envoyé",
        "NOT_SIGNED": "Non signé",
        "CANCELED": "Annulé"
      },
      "deposit_status": {
        "CREATING": "-",
        "PENDING": "En cours dépôt",
        "DONE": "Validé"
      },
      "null": "-",
      "creating": "À signer",
      "filling": "En cours dépôt",
      "signing": "En cours de signature",
      "validated": "Validé",
      "signed": "Signé",
      "not_signed": "Non signé",
      "manually": "Manuelle"
    },
    "table": {
      "header": {
        "identity": "Identité",
        "coordinates": "Adresse",
        "contract": "Contrat",
        "attachments": "Fichiers joints",
        "signature_request_type": "Type de procédure",
        "alert": "Alerte",
        "signature": "État de la procédure",
        "packages": "Packs d'avantages"
      }
    },
    "slide_over": {
      "title": "Ajouter un contrat"
    }
  },
  "attendee_contract": {
    "document_preview": {
      "save": "Sauvegarder le contrat",
      "download": "Télécharger le contrat",
      "delete": "Supprimer le contrat"
    }
  },
  "upload_contract_template": {
    "drag_and_drop_statement": "Veuillez sélectionner un fichier ou le drag and drop ici",
    "or_statement": "Seulement des fichiers de type .DOCX",
    "cta_label": "Sélectionnez un fichier",
    "document_name": "Nom du document",
    "download": "Télécharger un modèle de document",
    "uploaded_contract": "Modèles de documents ajoutés"
  },
  "toast": {
    "generation_failed": "La génération du zip a échoué"
  },
  "popup_modal_mass_delete": {
    "button": "Supprimer les contrats",
    "title": "Confirmation de suppression",
    "warning": "Êtes-vous sûr de vouloir supprimer les contrats non signés de l’invité sélectionné ? | Êtes-vous sûr de vouloir supprimer les contrats non signés des {count} invités sélectionnés ?",
    "validate": "Confirmer la suppression"
  }
}
